

//  React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    overflowY: "auto",
    scrollbarGutter: "stable",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  "body::before": {
    content: '""',
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0)",
    backdropFilter: "blur(0px)",
    WebkitBackdropFilter: "blur(0px)",
    opacity: 0,
    pointerEvents: "none",
    zIndex: 1300,
    transition:
      "opacity 220ms ease, background-color 220ms ease, backdrop-filter 220ms ease, -webkit-backdrop-filter 220ms ease",
  },
  "body.controller-card-hovered::before": {
    backgroundColor: "rgba(0, 0, 0, 0.18)",
    opacity: 1,
  },
  "body.controller-card-hovered .navbar": {
    zIndex: "1200 !important",
  },
  "body.new-home-modal-open .navbar": {
    zIndex: "1200 !important",
  },
};

export default globals;
